import { request } from '@/common/request';
import { apiOrigin } from '@/common/config';

/**
 * 获取用户信息
 * @return { Object }
 * data: {
 *  isHasGoods: boolean // 是否是有货源
 *  isSetVersionId： boolean // 是否设置了版本
 *  tenantId: string | number
 *  userId: string | number
 *  phone: string
 *  tenantType: number 租户类型 0爱库存 1头部 2企业  3阿基米德 4团长大营
 *  nickName: string
 *  gender: number 性别：-1-未知 0-男 1-女
 *  versionId: number
 *  dccTenantAjmdLogoutUrl: string // 退出之后重定向的地址
 *  headPortrait: 头像
 * tenantDefaultFlag: 租户默认用户标识：0-否 1-是
 * }
 */
export const ApiGetUserInfo = () => {
    return request({
        url: `${apiOrigin}/api/saas/backend/sysTenantUser/getBaseUserInfo`,
        method: 'get'
    });
};

/**
 * 人中心-更新用户基本信息
 * @param {Object}
 * data: {
 *  headPortrait: string
 *  gender: string
 * }
 */
export function ApiUpdateUserInfo(data) {
    return request({
        url: `${apiOrigin}/api/saas/backend/sysTenantUser/updateBaseInfo`,
        method: 'POST',
        data
    });
}

/**
 * 个人中心-更新手机号
 * @param {Object}
 * data: {
 *  oldAuthCode: string
 *  newAuthCode: string
 *  newPhone: string
 * }
 */
export function ApiUpdateUserPhone(data) {
    return request({
        url: `${apiOrigin}/api/saas/backend/sysTenantUser/updatePhone`,
        method: 'POST',
        data
    });
}

/**
 * 个人中心-更新密码
 * @param {Object}
 * data: {
 *  authCode: string
 *  newPwd: string
 * }
 */
export function ApiUpdateUserPassword(data) {
    return request({
        url: `${apiOrigin}/api/saas/backend/sysTenantUser/updatePwd`,
        method: 'POST',
        data
    });
}
